/**
 * @author LiuZhaowen
 * @date 2023-07-26
 * @name 自定义刻度尺插件
 * @props 配置参数
 * 通用参数：
 * @targetEl 元素 node 对象，作为canvas 的父元素, 必传
 * @canvasHeight String || Number, canvas 高度， 默认 100px
 * @backgroundColor String, canvas背景颜色， 默认 #fff
 * @fontColor String, canvas 内字体颜色，默认 #222
 * @fontStyle string，canvas 字体样式，默认  14px Arial
 * @lineColor String 刻度尺线条颜色, 默认 #222
 * @pointerLineColor String 指针线条颜色 包括圆圈的颜色  默认取 lineColor 值
 * @pointerHasCircle Boolean 指针是否有圆球
 * @isConstant Boolean 是否响应式触发 callback
 * @callback Function 能够获取当前的数据
 * @initValue String || Number 初始值，如果初始值不在数据范围内则取数据范围的第一个值
 * @startTip String 第一个值的备注文案
 * @endTip String 最后一个值的备注文案
 * @tipStyle Object 里面包含 color， fontSize，fontFamliy  没有设置跟 fontColor fontStyle 一致
 * 显示类型参数：
 * @dataType String 如果传’numbers‘代表数据是连续的，如果传’customer‘代表数据是指定的, 默认是 numbers
 * dataType == numbers 时需要以下参数
 * @numberRegion Array<Number>，连续数字对应的数据范围，例：[0,100] 默认[0,100]
 * @numberBlank Number, 两个数据间有多少个小格 从 0 开始，默认为 9，即两个数据间有 10 个小格
 * dataType == customer 时需要以下参数
 * @customerDataList Array<String || Number> 所有的数据组成的列表，每个值都会作为表的显示刻度
 * @customerNumberBlank Number 刻度显示文案的间隔 从 0 开始 默认为 1即两个文案直接有两个空格 中间的刻度不显示文案
 * @customerPageShow Number 刻度尺一页显示多少个刻度 从 0  开始 默认为 9 即一页显示 10 个刻度
 */
let CRulerInitTime = 0
const CRuler = {
    initRuler:(props) => {
        CRulerInitTime+=1
        const {
            // 通用参数
            targetEl,
            canvasHeight = 100,
            backgroundColor = '#fff',
            fontColor = '#222', // 字体颜色
            fontStyle = '14px Arial', // 字体样式
            lineColor = '#222', // 线条颜色
            pointerLineColor = lineColor, // 主线条颜色
            pointerHasCircle = true, // 指针是否有圆球
            isConstant = true, // 数据只要变就触发 callback
            callback, // 回调函数
            initValue,
            startTip,
            endTip,
            tipStyle,
            //
            dataType = 'numbers',
            numberBlank = 9,
            numberRegion = [0,100],
            //
            customerDataList,
            customerNumberBlank = 1, // 两个数字间的间隔 从 0 开始
            customerPageShow = 9, // 一页显示几个 从 0 开始
        } = props

        console.log(`${CRulerInitTime} CRuler props: `,props)

        /**
         * 初始化
        */
        // 判断是否有 targetEl
        if(!targetEl){
            console.warn("cRuler: targetEl 不存在！")
            return
        }
        //容器宽度
        let winWidth = targetEl.offsetWidth

        // 第一步创建 canvas 元素
        // 判断父元素中是否已经渲染了 canvas
        const canvasOld = targetEl?.getElementsByClassName("cRulerWrap")[0]

        if(canvasOld){
            // 有的话先清掉
            targetEl.removeChild(canvasOld)
        }
        // 创建新的 canvas
        let canvasNew = document.createElement("canvas")
        canvasNew.classList.add('cRulerWrap')
        canvasNew.width = winWidth
        canvasNew.height = canvasHeight
        targetEl.appendChild(canvasNew)
        let cxt = canvasNew.getContext('2d')
        // 根据设备缩放
        if(window.devicePixelRatio){
            canvasNew.width = window.devicePixelRatio * winWidth
            canvasNew.height = window.devicePixelRatio * canvasHeight
            canvasNew.style.transform = `scale(${1/window.devicePixelRatio})`
            canvasNew.style.transformOrigin = "left top"
            cxt.scale(window.devicePixelRatio, window.devicePixelRatio)
        }
        let canvas = canvasNew


        /**
         *根据 dataType 作判断
        * */

        const isCustomer = dataType == 'customer'
        let startValue, endValue, division
        //刻度值数组
        let scaleValueList = []
        if(dataType == 'numbers'){
            // console.log('in num')
            scaleValueList = []
            // 1. 连续数据
            startValue = Number(numberRegion?.[0]) || 0
            endValue = Number(numberRegion?.[1]) || 100
            let initValueData = isNaN(Number(initValue))?0: Number(initValue)
            // 初始值防止越界
            if(initValueData > endValue){
                initValueData = endValue
            } else if(initValueData < startValue){
                initValueData = startValue
            } else if(isNaN(initValue)){
                initValueData = startValue
            }
            for(let i = startValue; i <= endValue; i+=(numberBlank+1)){
                scaleValueList.push(i)
            }
            // 计算每个小格的宽度
            division = winWidth / ((numberBlank + 1) * 3)
            // console.log(scaleValueList, division)

            // 填充 canvas
            const drawRuler = (initValueData) => {
                // console.log("drawRuler【num】, initValueData: ", initValueData)
                // 左边的 0 能放到中间的位置
                initValueData-=((numberBlank + 1) * 3) / 2
                // const heightTotal = canvas.height
                const heightTotal = canvasHeight
                //清空画布
                cxt.clearRect(0,0,winWidth, heightTotal)
                //刻度尺背景
                if(backgroundColor){
                    cxt.fillStyle = backgroundColor
                    cxt.fillRect(0, 0, canvas.width, heightTotal)
                }

                // 添加刻度
                for(let i = startValue; i <= endValue; i++){
                    cxt.beginPath()
                    cxt.save()
                    cxt.strokeStyle = lineColor
                    cxt.lineWidth = 1;
                    cxt.lineCap = "round"
                    const xValue = division * i - initValueData * division
                    const yValue = 7
                    cxt.moveTo(xValue, yValue)
                    // 基础线长
                    cxt.lineTo(xValue, Math.floor(heightTotal * 0.3))

                    // 偶数小格让中间的小格变长一点
                    if(((numberBlank + 1) % 2 == 0) && (i % ((numberBlank + 1) / 2) === 0) && (i % (numberBlank + 1) !== 0)){
                        cxt.strokeStyle = lineColor
                        cxt.lineTo(xValue, Math.floor(heightTotal * 0.35))
                    }

                    // 大格线长
                    if(i % (numberBlank + 1) === 0){
                        cxt.strokeStyle = lineColor
                        cxt.lineTo(xValue, Math.floor(heightTotal * 0.45))
                    }

                    cxt.stroke()
                    cxt.restore()
                    cxt.closePath()
                }

                // 添加刻度顶部条
                cxt.beginPath()
                cxt.strokeStyle = lineColor
                cxt.lineWidth = 1;
                cxt.lineCap = "round"
                cxt.moveTo(division * startValue - initValueData * division,  7)
                cxt.lineTo(division * endValue - initValueData * division , 7)
                cxt.stroke()
                cxt.restore()
                cxt.closePath()

                // 添加刻度文本
                cxt.beginPath()
                cxt.textAlign = 'center'
                cxt.textBaseline = 'middle'
                scaleValueList.forEach((num, i) => {
                    cxt.font = fontStyle
                    cxt.fillStyle = fontColor
                    const textXValue = (division * i * (numberBlank + 1) - ((initValueData - startValue) * division))
                    cxt.fillText(num.toString(), textXValue, Math.floor(heightTotal * 0.65))
                    if( i == 0 ){
                        if(tipStyle?.fontSize){
                            cxt.font = `${tipStyle?.fontSize} ${tipStyle?.fontFamliy || 'Roboto'} `
                        }
                        if(tipStyle?.color){
                            cxt.fillStyle = tipStyle?.color
                        }
                        cxt.fillText(startTip || '', textXValue, Math.floor(heightTotal * 0.8))
                    } else if( i == scaleValueList?.length - 1){
                        if(tipStyle?.fontSize){
                            cxt.font = `${tipStyle?.fontSize} ${tipStyle?.fontFamliy || 'Roboto'} `
                        }
                        if(tipStyle?.color){
                            cxt.fillStyle = tipStyle?.color
                        }
                        cxt.fillText(endTip || '', textXValue, Math.floor(heightTotal * 0.8))
                    }
                })
                cxt.closePath()

                // 添加中心指针圆球
                if(pointerHasCircle){
                    cxt.beginPath()
                    cxt.save()
                    cxt.strokeStyle = pointerLineColor
                    cxt.lineWidth = 2;
                    cxt.lineCap = "round"
                    cxt.moveTo(winWidth / 2,  7)
                    cxt.arc(winWidth / 2,  8, 7, 0, 2 * Math.PI)
                    cxt.stroke()
                    cxt.closePath()
                    cxt.fillStyle = '#fff'
                    cxt.fill()
                }

                // 添加中心指针
                cxt.beginPath()
                cxt.strokeStyle = pointerLineColor
                cxt.lineWidth = 2;
                cxt.lineCap = "round"
                if(pointerHasCircle){
                    cxt.moveTo(winWidth / 2,  17)
                } else {
                    cxt.moveTo(winWidth / 2,  7)
                }
                cxt.lineTo(winWidth / 2 , Math.floor(heightTotal * 0.5))
                cxt.stroke()
                cxt.restore()
                cxt.closePath()
            }

            drawRuler(initValueData)

            // 滑动部分
            let initX = 0, //初始x 距离
                endX = 0, //结束x 距离
                distanceX = 0, //移动距离
                _distanceX = 0,// 判断用的移动距离
                lastX = Number(initValueData); //上次移动距离
            if (!canvas) return false;

            //手指按下
            canvas.addEventListener("touchstart", function (e) {
                initX = e.targetTouches[0].pageX;
                // console.log('touchstart', initX)
            }, false);

            //手指滑动
            canvas.addEventListener("touchmove", function (e) {
                endX = e.targetTouches[0].pageX;
                // // console.log('touchmove', endX)
                moveEvent();
            }, false);

            //手指抬起
            canvas.addEventListener("touchend", function (e) {
                lastX = initValueData;
                // console.log('touchend', lastX)
                overEvent();
            }, false);

            var isMouseDown = false; //鼠标是否按下

            //鼠标按下
            canvas.addEventListener("mousedown", function (e) {
                isMouseDown = true;
                initX = e.layerX;
                // console.log('mousedown', initX)
            }, false);

            //鼠标移动
            canvas.addEventListener("mousemove", function (e) {
                if (!isMouseDown) {
                    return false;
                }
                endX = e.layerX;
                // // console.log('mousemove', endX)
                moveEvent();
            }, false);

            //鼠标抬起&离开
            canvas.addEventListener("mouseup", function (e) {
                lastX = initValueData;
                isMouseDown = false;
                // console.log('mouseup', lastX)
                overEvent();
            }, false);

            canvas.addEventListener("mouseleave", function (e) {
                if (isMouseDown) {
                    lastX = initValueData;
                    // console.log('mouseleave', lastX)
                    isMouseDown = false;
                    overEvent();
                }
            }, false);

            //手指&鼠标移动事件
            const moveEvent = () => {
                // 计算移动了多少格
                // console.log('_distanceX: ',_distanceX)
                distanceX = - ((endX - initX) / division)
                if (distanceX === _distanceX) {
                    return false;
                }
                _distanceX = distanceX;
                // console.log('distanceX: ',distanceX, lastX, initValueData)
                initValueData = Number(lastX) + distanceX;

                if (initValueData >= endValue || initValueData <= startValue) {
                    initValueData = initValueData >= endValue ? endValue : startValue;
                }
                drawRuler(initValueData);

                if (isConstant) {
                    // 返回数据
                    // callback && callback(initValueData);
                    callback && callback(Math.floor(initValueData));
                }
            }

            //手指&鼠标结束事件
            const overEvent = () => {
                if (initValueData > endValue) {
                    lastX = initValueData = initValueData > endValue ? endValue : Math.floor(initValueData);
                } else if (initValueData < startValue) {
                    lastX = initValueData = initValueData < startValue ? startValue : Math.floor(initValueData);
                } else {
                    initValueData = Math.floor(initValueData)
                }
                drawRuler(initValueData);

                //返回最后的值
                callback && callback(initValueData);
            }
            //初始化值
            // console.log(initValueData)
            callback && callback(initValueData);
        } else {
            // 2. 指定数据
            // console.log('in customer', customerDataList)
            scaleValueList = []
            if(customerDataList?.length <= 0){
                console.warn('CRuler: 缺少数据!!')
                return false
            } else {
                scaleValueList = customerDataList
                startValue = 0
                endValue = customerDataList?.length - 1
            }
            // 初始值的 index
            let initValueIndex = customerDataList?.findIndex(c => c == initValue) > 0 ? customerDataList?.findIndex(c => c == initValue): 0

            // 每格间距
            division = winWidth / (customerPageShow + 1)

            // 填充 canvas
            const drawRuler = (initValueIndex) => {
                // console.log("drawRuler【com】, initValueIndex: ", initValueIndex)
                initValueIndex -= (customerPageShow + 1) / 2

                // const heightTotal = canvas.height
                const heightTotal = canvasHeight
                //清空画布
                cxt.clearRect(0,0,winWidth, heightTotal)
                //刻度尺背景
                if(backgroundColor){
                    cxt.fillStyle = backgroundColor
                    cxt.fillRect(0, 0, canvas.width, heightTotal)
                }

                // 添加刻度
                for(let i = 0; i <= scaleValueList?.length - 1; i++){
                    cxt.beginPath()
                    cxt.save()
                    cxt.strokeStyle = lineColor
                    cxt.lineWidth = 1;
                    cxt.lineCap = "round"
                    const xValue = division * i - initValueIndex * division
                    const yValue = 7
                    cxt.moveTo(xValue, yValue)
                    // 基础线长
                    cxt.lineTo(xValue, Math.floor(heightTotal * 0.3))

                    // 偶数小格让中间的小格变长一点
                    if(((customerNumberBlank + 1) % 2 == 0) && (i % ((customerNumberBlank + 1) / 2) === 0) && (i % (customerNumberBlank + 1) !== 0)){
                        cxt.strokeStyle = lineColor
                        cxt.lineTo(xValue, Math.floor(heightTotal * 0.35))
                    }

                    // 大格线长
                    if(i % (customerNumberBlank + 1) === 0){
                        cxt.strokeStyle = lineColor
                        cxt.lineTo(xValue, Math.floor(heightTotal * 0.45))
                    }

                    cxt.stroke()
                    cxt.restore()
                    cxt.closePath()
                }

                // 添加刻度顶部条
                cxt.beginPath()
                cxt.strokeStyle = lineColor
                cxt.lineWidth = 1;
                cxt.lineCap = "round"
                cxt.moveTo(division * startValue - initValueIndex * division,  7)
                cxt.lineTo(division * endValue - initValueIndex * division , 7)
                cxt.stroke()
                cxt.restore()
                cxt.closePath()

                // 添加刻度文本
                cxt.beginPath()
                cxt.textAlign = 'center'
                cxt.textBaseline = 'middle'
                scaleValueList.forEach((num, i) => {
                    cxt.font = fontStyle
                    cxt.fillStyle = fontColor
                    const textXValue = division * i - (initValueIndex * division)
                    if(i % (customerNumberBlank + 1) == 0){
                        cxt.fillText(num.toString(), textXValue, Math.floor(heightTotal * 0.65))
                    }
                    if( i == 0 ){
                        if(tipStyle?.fontSize){
                            cxt.font = `${tipStyle?.fontSize} ${tipStyle?.fontFamliy || 'Roboto'} `
                        }
                        if(tipStyle?.color){
                            cxt.fillStyle = tipStyle?.color
                        }
                        cxt.fillText(startTip, textXValue, Math.floor(heightTotal * 0.8))
                    } else if( i == scaleValueList?.length - 1){
                        if(tipStyle?.fontSize){
                            cxt.font = `${tipStyle?.fontSize} ${tipStyle?.fontFamliy || 'Roboto'} `
                        }
                        if(tipStyle?.color){
                            cxt.fillStyle = tipStyle?.color
                        }
                        cxt.fillText(endTip, textXValue, Math.floor(heightTotal * 0.8))
                    }
                })
                cxt.closePath()

                // 添加中心指针圆球
                if(pointerHasCircle){
                    cxt.beginPath()
                    cxt.save()
                    cxt.strokeStyle = pointerLineColor
                    cxt.lineWidth = 2;
                    cxt.lineCap = "round"
                    cxt.moveTo(winWidth / 2,  7)
                    cxt.arc(winWidth / 2,  8, 7, 0, 2 * Math.PI)
                    cxt.stroke()
                    cxt.closePath()
                    cxt.fillStyle = '#fff'
                    cxt.fill()
                }

                // 添加中心指针
                cxt.beginPath()
                cxt.strokeStyle = pointerLineColor
                cxt.lineWidth = 2;
                cxt.lineCap = "round"
                if(pointerHasCircle){
                    cxt.moveTo(winWidth / 2,  17)
                } else {
                    cxt.moveTo(winWidth / 2,  7)
                }
                cxt.lineTo(winWidth / 2 , Math.floor(heightTotal * 0.5))
                cxt.stroke()
                cxt.restore()
                cxt.closePath()
            }
            drawRuler(initValueIndex)

            // 滑动部分
            let initX = 0, //初始x 距离
                endX = 0, //结束x 距离
                distanceX = 0, //移动距离
                _distanceX = 0,// 判断用的移动距离
                lastX = initValueIndex; //上次移动距离
            if (!canvas) return false;

            //手指按下
            canvas.addEventListener("touchstart", function (e) {
                initX = e.targetTouches[0].pageX;
                // console.log('touchstart', initX)
            }, false);

            //手指滑动
            canvas.addEventListener("touchmove", function (e) {
                endX = e.targetTouches[0].pageX;
                // // console.log('touchmove', endX)
                moveEvent();
            }, false);

            //手指抬起
            canvas.addEventListener("touchend", function (e) {
                lastX = initValueIndex;
                // console.log('touchend', lastX)
                overEvent();
            }, false);

            var isMouseDown = false; //鼠标是否按下

            //鼠标按下
            canvas.addEventListener("mousedown", function (e) {
                isMouseDown = true;
                initX = e.layerX;
                // console.log('mousedown', initX)
            }, false);

            //鼠标移动
            canvas.addEventListener("mousemove", function (e) {
                if (!isMouseDown) {
                    return false;
                }
                endX = e.layerX;
                // // console.log('mousemove', endX)
                moveEvent();
            }, false);

            //鼠标抬起&离开
            canvas.addEventListener("mouseup", function (e) {
                lastX = initValueIndex;
                isMouseDown = false;
                // console.log('mouseup', lastX)
                overEvent();
            }, false);

            canvas.addEventListener("mouseleave", function (e) {
                if (isMouseDown) {
                    lastX = initValueIndex;
                    // console.log('mouseleave', lastX)
                    isMouseDown = false;
                    overEvent();
                }
            }, false);

            //手指&鼠标移动事件
            const moveEvent = () => {
                // 计算移动了多少格
                distanceX = - Math.floor((endX - initX) / division);
                if (distanceX === _distanceX) {
                    return false;
                }
                _distanceX = distanceX;
                // console.log('distanceX: ',distanceX, lastX, initValueIndex)
                initValueIndex = Number(lastX) + distanceX;

                if (initValueIndex >= endValue || initValueIndex <= startValue) {
                    initValueIndex = initValueIndex >= endValue ? endValue : startValue;
                }
                drawRuler(initValueIndex);

                if (isConstant) {
                    // 返回数据
                    callback && callback(customerDataList?.[initValueIndex] || customerDataList?.[0]);
                }
            }

            //手指&鼠标结束事件
            const overEvent = () => {
                if (initValueIndex > endValue) {
                    lastX = initValueIndex = initValueIndex > endValue ? endValue : initValueIndex;
                } else if (initValueIndex < startValue) {
                    lastX = initValueIndex = initValueIndex < startValue ? startValue : initValueIndex;
                }
                drawRuler(initValueIndex);

                //返回最后的值
                callback && callback(customerDataList?.[initValueIndex] || customerDataList?.[0]);
            }
            //初始化值
            // customerDataList?.[initValueIndex] || customerDataList?.[0]
            callback && callback(customerDataList?.[initValueIndex] || customerDataList?.[0]);
        }
    }
}

export default CRuler